/**
 * Contraste de texto sobre uma cor de fundo — regra ÚNICA do sistema.
 *
 * Usa a luminância relativa do WCAG (com linearização sRGB). A média simples
 * dos canais erra em cores saturadas: azul puro tem média alta e é escuro.
 *
 * Consumidores: blocos de sessão do calendário e cabeçalho de sessão do
 * programa exportável.
 */

/** Luminância relativa (0 = preto, 1 = branco). Cores inválidas → 1. */
export function relativeLuminance(background: string): number {
  const hex = (background || '').replace('#', '');
  if (hex.length !== 3 && hex.length !== 6) { return 1; }

  const full = hex.length === 3 ? hex.split('').map(c => c + c).join('') : hex;
  const channel = (start: number): number => {
    const value = parseInt(full.substr(start, 2), 16) / 255;
    return value <= 0.03928 ? value / 12.92 : Math.pow((value + 0.055) / 1.055, 2.4);
  };

  return 0.2126 * channel(0) + 0.7152 * channel(2) + 0.0722 * channel(4);
}

/** `true` quando o fundo é claro o bastante para texto escuro. */
export function isLightBackground(background: string): boolean {
  return relativeLuminance(background) > 0.4;
}
